export default "__VITE_ASSET__e283faef__"